// extracted by mini-css-extract-plugin
export default {"sib-close":"Kv98euv0esMKKlH0kqjg","sib-btn":"MdvJwanIVxJWrhoNdNYA","sib-btn_icon-stand-alone":"_r5A6cZOow1dPcL7jDSC","sib-btn_size--small":"ciZFX7hfgWLiUwHtwtOQ"};